<div id="content">
    <app-header></app-header>
    <div class="rs-container">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</div>





